import { useCustomer } from '@app/user';
/* eslint-disable no-underscore-dangle */
import { useEffect } from 'react';
import { DOM, isBrowser } from '@app/utils';
import { config } from '@app/config';

const hasSift = () => {
  if (isBrowser) {
    return window._sift;
  }

  return null;
};

const useSift = () => {
  const customer = useCustomer();

  useEffect(() => {
    if (!hasSift() && isBrowser) {
      const _user_id = customer?.uuid; // Set to the user's ID, username, or email address, or '' if not yet known.
      const _session_id = DOM.getCookie('stockx_session'); // Set to a unique session ID for the visitor's current browsing session.

      // eslint-disable-next-line no-multi-assign
      const _sift = (window._sift = window._sift || []);
      if (config.ENVIRONMENT === 'production') {
        _sift.push(['_setAccount', 'e2e1d9d7d0']);
      } else {
        _sift.push(['_setAccount', '9c2d29e6c6']);
      }

      _sift.push(['_setUserId', _user_id]);
      _sift.push(['_setSessionId', _session_id]);
      _sift.push(['_trackPageview']);

      (function () {
        function ls() {
          const e = document.createElement('script');
          e.src = 'https://cdn.sift.com/s.js';
          document.body.appendChild(e);
        }

        if (window.attachEvent) {
          window.attachEvent('onload', ls);
        } else {
          window.addEventListener('load', ls, false);
        }
      }());
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useSift;
